module.exports = __webpack_public_path__ + "img/fagao1.a3b7b608.png";